import axiosInstance from "../../axiosInstance";

const createIssue = async (data) => {
  try {
    const res = await axiosInstance.post(`/api/issue/create`, data);

    if (res.status === 201) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

export default createIssue;
